<template>
  <PostOrderInstructionPatrolMenuButton
    v-if="instructionType === PostOrderInstructionTypeEnum.Patrol"
    :instructions="instructions"
    :is-instruction-type-selected="isInstructionTypeSelected"
    :post-order-id="postOrderId"
    @select-instruction="emit('select-instruction', $event)"
    @create-instruction="emit('create-instruction', $event)"
    @no-instruction-selected="emit('no-instruction-selected', $event)"
    @instruction-deleted="emit('instruction-deleted', $event)"
  />

  <v-btn
    v-else
    :variant="isInstructionTypeSelected ? 'outlined' : 'flat'"
    class="text-h6 px-8"
    :color="isInstructionTypeSelected ? 'success' : ''"
    :active="isInstructionTypeSelected"
    @click="selectStartOrEndOfShiftInstruction(instructions)"
  >
    {{ instructionType === PostOrderInstructionTypeEnum.Start ? 'Start of Shift' : 'End of Shift' }}
  </v-btn>
</template>

<script setup lang="ts">
import { type IPostOrderInstruction, PostOrderInstructionTypeEnum } from '@/models/post-order'
import PostOrderInstructionPatrolMenuButton from './PostOrderInstructionPatrolMenuButton.vue'

interface Props {
  instructionType: PostOrderInstructionTypeEnum
  instructions?: IPostOrderInstruction[]
  isInstructionTypeSelected: boolean
  postOrderId: number
}
const props = withDefaults(defineProps<Props>(), {
  instructions: (): IPostOrderInstruction[] => []
})

interface Emits {
  (e: 'select-instruction', instruction: IPostOrderInstruction): void
  (e: 'create-instruction', type: PostOrderInstructionTypeEnum): void
  (e: 'no-instruction-selected', type: PostOrderInstructionTypeEnum): void
  (e: 'instruction-deleted', instructionId: number): void
}
const emit = defineEmits<Emits>()

function selectInstruction(instruction: IPostOrderInstruction | null) {
  if (!instruction) {
    emit('no-instruction-selected', props.instructionType)
  } else {
    emit('select-instruction', instruction)
  }
}

function selectStartOrEndOfShiftInstruction(instructions: IPostOrderInstruction[]) {
  if (instructions.length > 0) {
    selectInstruction(instructions[0])
  } else {
    emit('no-instruction-selected', props.instructionType)
  }
}
</script>
